export default "__VITE_ASSET__rUb_n7cn__"